import {
  FIELD_DF,
  FIELD_NM,
  FIELD_ST,
  FIELD_ID,
  FIELD_SN,
  FIELD_Z0,
  FIELD_PARENT_ID,
  LENGTH_STR_FIELD,
  FIELD_PRODUCT_CODE,
} from './fields';

/**
 * == Used to check if a property is valid `numeric` dimension field through: ==
 * for `isDimensionField` function
 * Define all the fields used in fittings and pipes...
 * As a field name standard/dict used in codes
 * TODO: Add more fields ...
 */
export enum FIXTUREATTRS {
  A1 = 'angle',
  D1 = 'diameter_1',
  D2 = 'diameter_2',
  D3 = 'diameter_3',
  D4 = 'diameter_4',
  H1 = 'height_1',
  H2 = 'height_2',
  H3 = 'height_3',
  W1 = 'width_1',
  W2 = 'width_2',
  W3 = 'width_3',
  VL = 'vertical_length',
  /** for `Silencer` symbol - @2025/03/07 */
  L0 = 'length',
}

/**
 * check dimension type to decide if the input is `number` type
 * @param field
 * @returns
 */
export const isDimensionField = (field: string) => {
  const dimensions = Object.values(FIXTUREATTRS) as string[];
  return dimensions.includes(field);
};

/**
 * Include all the `string` dimension for review table input
 * FIXME: hard-coded fields from `EQUIPMENT` - @2023/11/17
 * FIXME: add `diffuser_code` for `SUPPLY_AIR_DIFFUSER` - @2024/11/12
 * FIMXE: add `identifier` for `EQUIPMENT` - @2024/12/10
 * FIXME: add `product_code` for TOILET symbol - @2025/01/17
 * FIXME: add `length_unit_str` for `duct_length` - @2025/03/11
 * FIXME: add `zone` for all symbol - @2025/06/27
 * FIXME: add `parentId` for insulation - @2026/06/08
 */
export const stringTypeFields = [
  FIELD_NM,
  FIELD_ST,
  FIELD_SN,
  FIELD_DF,
  FIELD_ID,
  FIELD_PRODUCT_CODE,
  LENGTH_STR_FIELD,
  FIELD_Z0,
  FIELD_PARENT_ID,
];
